'use client';
import { useQuery } from '@tanstack/react-query';

import { accountSSOOptionsFetcher } from '~/fetchers/accountSSOOptionsFetcher';

export const ACCOUNT_SSO_OPTIONS_KEY = 'ACCOUNT_SSO_OPTIONS';

export const getAccountSSOOptionsKey = (params: UseAccountSSOOptionsParams) => {
  return [ACCOUNT_SSO_OPTIONS_KEY, params];
};

export type UseAccountSSOOptionsParams = {
  email: string;
};

export const useAccountSSOOptions = (params: UseAccountSSOOptionsParams) => {
  return useQuery({
    enabled: !!params.email,
    queryFn: () => accountSSOOptionsFetcher({ email: params.email }),
    queryKey: getAccountSSOOptionsKey(params),
  });
};
